import { Component, OnInit, Input } from '@angular/core';
import { BaseComponentService } from '../../services/base-component.service';
import { GrupoComponent } from './grupo.component';

@Component({
  selector: 'gpa-modal-grupo',
  templateUrl: './modal-grupo.component.html',
  providers: [BaseComponentService]
})

export class ModalGrupoComponent extends BaseComponentService implements OnInit {

  @Input()
  modoEdicao: boolean = false;
  @Input()
  projetosGruposAssociados: any[] = [];

  projetos: any[] = [];
  projeto: any;
  grupos: any[] = [];
  grupo: any;

  ngOnInit() {
    this.projeto = '';
    this.grupo = '';
 
    this.preencheCombo('/api/InformacaoProjeto/ObterProjetosIntegrados', 'projetos', 'gpa');
    this.preencheCombo('/api/GrupoUsuarioProjeto/ObterTodos', 'grupos', 'gpa');    
  }

  salvarOnClick() {

   const existeAssociacao = this.projetosGruposAssociados.some(x =>
    x.codProjetoIntegradoPagamentoAutomatico.trim() === this.projeto.trim() &&
    x.codGrupo.trim() === this.grupo.trim()
    );

    if (existeAssociacao) {
            this.exibirAviso('Já existe uma associação entre o projeto e o grupo selecionados.');
            return;
    }

    const dto = {
      codProjetoIntegradoPagamentoAutomatico: this.projeto,
      codGrupo: this.grupo,
    };

    this.aslibLoadingService.start();
    this._service.routePrefix = '/api/ControleAcessoPagamentoAutomatico/';

    this.subSave = this._service.add(dto, 'gpa').subscribe(data => {
        GrupoComponent.updateList.next(data);
        this.exibirSucesso('Associação do grupo salva com sucesso.');
      },
      erro => {
        this.exibirErro(erro);
      },
      () => {
        this.aslibLoadingService.complete();
      }
    ); 
  }

  cancelarOnClick() {
    GrupoComponent.updateList.next('');
  }
}



// WEBPACK FOOTER //
// ./src/app/controle-dados/grupo/modal-grupo.component.ts